Vue.component('comp-records', {

    props: ['records', 'citations', 'citationsPositions', 'hallnames', 'itemsOffsetTop'],

    data: function() {
        return {
            availableDays: [],
            citationCount: -1
        }
    },

    methods: {
        getRandom(min, max) {
            return Math.floor(Math.random() * (max - min + 1)) + min;
        },

        isCitationReady(index) {
            return this.citationsPositions[index] && this.citations[index];
        },

        getCitation(index) {
            return this.citations[index];
        },

        showDayDivider(index) {
            if (!index) return false;
            console.log("this.records[index-1]: ", this.records[index-1]);
            return !(this.records[index-1] && (moment(this.records[index].date).date() === moment(this.records[index-1].date).date()) && (moment(this.records[index].date).month() === moment(this.records[index-1].date).month()));
            return true
        },

        hideDay(index) {
            return (this.records[index-1] && (moment(this.records[index].date).date() === moment(this.records[index-1].date).date()) && (moment(this.records[index].date).month() === moment(this.records[index-1].date).month()));
        },

        hideTime(index) {
            let record = this.records[index];
            if (!record || !record.hasOwnProperty('more') || !record.more || !record.more.hasOwnProperty('disable_time')) {
                return false;
            }
            return record.more.disable_time;
        },

        getItemsOffsetTop() {
            let itemsOffsetTop = [];
            $('.program-item').each(function () {
                itemsOffsetTop.push($(this).offset().top);
            });

            this.itemsOffsetTop = itemsOffsetTop;
            this.$emit('itemsOffsetTop', this.itemsOffsetTop);
        },

        lastTicketsText(rec) {
            if (this.getBuyTicketText(rec) !== 'Koupit vstupenku') return "";
            if (rec.more && rec.more.category.indexOf("pro-skoly") >= 0) return "";

            let tickets = rec.capacity.free;
            if (tickets > 4) return `Posledních<br>${tickets} vstupenek`;
            else if (tickets > 1 && tickets < 5) return `Poslední<br>${tickets} vstupenky`;
            else return `Zbývá poslední<br>vstupenka`;
        },

        getBuyTicketClassList(rec) {
            let buyTicketClassList = "btn btn-program";

            if (
                rec.isArchive ||
                !rec.sale_available ||
                (rec.more && (
                    rec.more.category.indexOf("zadane") >= 0 || rec.more.category.indexOf("__cat-zadane") >= 0 ||
                    rec.more.category.indexOf("zruseno") >= 0 || rec.more.category.indexOf("__cat-zruseno") >= 0 ||
                    rec.more.category.indexOf("pro-skoly") >= 0 || rec.more.category.indexOf("__cat-pro-skoly") >= 0 ||
                    rec.more.free ||
                    rec.more.first_row
                ))
            ) {
                buyTicketClassList += " btn-main disabled";
            } else if (!rec.capacity.available) {
                buyTicketClassList += " btn btn-program btn-main-reverse btn-sold-out";
            } else {
                buyTicketClassList += " btn-main";
            }

            return buyTicketClassList;
        },

        noSaleCategory(rec) {
            let prohibitedSaleCategories = ["zadane", "pro-skoly", "herecky-kurz"];
        },

        getBuyTicketText(rec) {
            if (rec.isArchive) {
                return 'Odehráno';
            } else if (rec.more && rec.more.free) {
                return 'Vstup zdarma';
            } else if (rec.more && rec.more.first_row) {
                return 'První řada';
            } else if (
                rec.more &&
                (rec.more.category.indexOf("zadane") >= 0 || rec.more.category.indexOf("__cat-zadane") >= 0)
            ) {
                return 'Zadáno';
            } else if (
                rec.more &&
                (rec.more.category.indexOf("zruseno") >= 0 || rec.more.category.indexOf("__cat-zruseno") >= 0)
            ) {
                return 'Zrušeno';
            } else if (
                rec.more &&
                (rec.more.category.indexOf("pro-skoly") >= 0 || rec.more.category.indexOf("__cat-pro-skoly") >= 0)
            ) {
                return 'Pro školy';
            // } else if (rec.more && rec.more.category.indexOf("herecky-kurz")) {
            //     return 'Herecký kurz';
            } else if (!rec.sale_available) {
                return 'V prodeji od ' + moment(String(rec.date_sale_from)).format('D. M.');
            } else if (rec.sale_available && !rec.capacity.available && rec.capacity.free == 0) {
                return '<span class="so-text">Vyprodáno</span><div class="so-box d-flex justify-content-center align-items-center"><span class="so-icon"></span></div>';
            }
            return 'Koupit vstupenku';
        },

        buyTicket(rec) {
            if (
                rec.isArchive ||
                !rec.sale_available ||
                //!rec.capacity.available ||
                //(rec.capacity.available && rec.capacity.free == 0) ||
                (rec.more && (
                    rec.more.free ||
                    rec.more.first_row
                ))
            ) {
                return;
            }

            let $form = $(".buy-link-form");
            $form.find("[name='eventid']").val(rec.PRDID);
            $form.submit();
        },

        shortShow(rec) {
            let hall = this.hallnames.find(item => item.name === rec.hall);
            rec.shortshow = !hall.active;
            return hall.active;
        },

        showHall(rec) {
            return (!rec.more || rec.more.category.indexOf("prohlidka-zakulisi") < 0);
        },

        getPriceRangeText(minPrice, maxPrice, rec) {
            if (!minPrice || parseInt(minPrice) === 0 || this.getBuyTicketText(rec) !== 'Koupit vstupenku') {
                return '&nbsp;';
            }

            if (minPrice === maxPrice) {
                return 'Jednotná cena ' + minPrice + ' Kč';
            }

            return `Od ${minPrice} Kč do ${maxPrice} Kč`;
        }
    },

    filters: {
        dateShortName(value) {
            return moment(String(value)).format('dd')
        },
        dateDay(value) {
            return moment(String(value)).format('D')
        },
        dateMonthName(value) {
            return moment(String(value)).format('M')
        },
        dateTime(value) {
            return moment(String(value)).format('HH.mm')
        },
        dateSaleFrom(value) {
            return moment(String(value)).format('D.M.YYYY')
        }
    },

    mounted() {
        let scope = this;

        $(window).on('resize', function () {
            scope.getItemsOffsetTop()
        });
    },

    updated: function () {
        this.getItemsOffsetTop();
        $('[data-toggle="popover"]').popover();
    },

    watch: {
        hallnames: {
            handler: function () {
                this.getItemsOffsetTop()
            },
            deep: true
        }
    },

    template:
`
<div id="events-container" class="container py-5">
    <div v-for="(rec, index) in records" class="row program-item" :data-day="rec.dates.day" :data-month="rec.dates.month" :data-year="rec.dates.year" :data-id="rec.rec_id">            
        <div class="col-12 p-relative pt-4" v-if="showDayDivider(index)">
            <div class="program-extra-month" v-if="rec.dates.firstInMonth">{{rec.dates.monthStr}}</div>
            <div class="divider mb-4"></div>
        </div>
        
        <comp-citation v-else-if="isCitationReady(index)" :citation="getCitation(index)"></comp-citation>
        
        <div class="col-auto text-center" :class="hideDay(index) ? 'invisible' : ''">
            <div class="fsz-h2 ff-ae-b mb-2 mt-lg-custom">{{rec.date | dateDay}}<span class="d-lg-none">.{{rec.date | dateMonthName}}.</span></div>
            <div class="text-uppercase">{{rec.date | dateShortName}}</div>
        </div> 
        
        <div class="col">
            <article>
                <div class="row" :class="hideDay(index) ? '' : 'd-none'">
                    <div class="col-12 col-md-80 ml-auto mb-1"><hr class="dashed"></div>    
                </div>

                <div class="row" v-if="rec.more && rec.more.labels && rec.more.labels.length">
                    <div class="col-12 col-md-20 mb-3"></div>
                    <div class="col">
                        <div v-if="rec.more && rec.more.labels" class="mb-2"> 
                            <span v-for="label in rec.more.labels" v-if="label !== ''" class="badge badge-main mr-1 mb-1 text-uppercase">{{label}}</span>
                        </div>
                    </div>
                </div>
            
                <div class="row">
                    
                    <div class="col-12 col-md-20 mb-3">
                        <div class="row">
                            <div class="col pl-md-0 pr-1 text-lg-center custom-line-height-2 ff-ae-b" :class="hideTime(index) ? 'invisible' : ''">{{rec.date | dateTime}}</div>
                            <div class="col p-0"> 
                                <strong class="text-uppercase custom-line-height-2" v-if="showHall(rec)">{{rec.scene}}</strong>
                                <div v-if="rec.more && rec.more.premiere" class="py-2 text-uppercase color-red">Premiéra</div>
                            </div>
                        </div>
                    </div>
                    
                    <div class="col mb-3 mb-sm-0">
                        <a v-if="rec.link && rec.name != 'Vánoce u Čapků aneb jak Karel a Olinka vařili dort cukroví'" v-bind:href="rec.link" class="text-uppercase just-hover-underline"><h2>{{rec.name}}</h2></a>
                        <a v-else-if="rec.link && rec.name == 'Vánoce u Čapků aneb jak Karel a Olinka vařili dort cukroví'" v-bind:href="rec.link" class="text-uppercase just-hover-underline"><h2>Vánoce u Čapků aneb jak Karel a Olinka vařili <span style="text-decoration:line-through">dort</span> cukroví</h2></a>
                        <h2 v-else class="text-uppercase">{{rec.name}}</h2>
                        
                        <p class="mb-2 text-uppercase ff-ae-b" v-if="rec.writers">{{rec.writers}}</p>
                        <div v-html="rec.desc"></div>
                        <div v-if="rec.more && rec.more.description && rec.desc" class="mb-3"></div>
                        <div v-if="rec.more && rec.more.description" class="mb-0">{{rec.more.description}}</div>
                    </div>
                    
                    <div class="col-12 col-sm-auto d-flex flex-column justify-content-end text-right">
                        
                        <p class="fsz-medium text-uppercase max-w-10rem mb-2 align-self-end" v-if="rec.more && rec.more.short_description">{{rec.more.short_description}}</p>
                        
                        <p v-if="rec.capacity.available && rec.capacity.free <= 10 && rec.capacity.free != 0"
                        v-html="lastTicketsText(rec)"
                        class="text-buy-button-two font-weight-bold text-uppercase mb-2 text-right text-sm-left"></p>
                        
                        
                        <button v-if="rec.more && rec.more.info_button_text && rec.more.info_button_content" type="button" class="btn btn-program btn-main disabled" data-toggle="popover" data-trigger="focus" data-placement="top" :data-content="rec.more.info_button_content">{{rec.more.info_button_text}}</button>
                        
                        <button v-else-if="!rec.is_manually_added || (rec.more && rec.more.free)" v-on:click="buyTicket(rec)" v-bind:class="getBuyTicketClassList(rec)" v-html="getBuyTicketText(rec)"></button>
                        <a v-else-if="rec.is_manually_added" v-bind:href="rec.ext_link" target="_blank" class="btn btn-program btn-main">Koupit vstupenku</a>

                        <div class="mb-0 text-right text-md-left font-weight-bold fs-14" v-html="getPriceRangeText(rec.price_min, rec.price_max, rec)"></div>
                    </div>
                    
                </div>
            </article>
        </div>
        
    </div>  
    
</div>
`
});

Vue.component('comp-calendar', {
    props: [
        'actualDate',
        'records',
        'timeline',
        'hallnames',
        'itemsOffsetTop',
    ],

    data: function() {
        return {
            today: moment(),
            actualMonth: '',
            items: [],
            activeFilterHallNames: []
        }
    },

    methods: {
        isItAvailableDay(day, month) {
            let todayEvents = this.timeline.filter((item) => {
                if (this.activeFilterHallNames.length) {
                    return (item.day === day && item.month === month) && this.activeFilterHallNames.indexOf(item.hall) >= 0;
                } else {
                    return (item.day === day && item.month === month);
                }

            });

            if (day === parseInt(this.today.format('D')) && month === parseInt(this.today.format('M'))) {
                return todayEvents.length ? 'available-today' : 'today'
            }

            return todayEvents.length ? 'available' : ''
        },

        availabilityInDay(day, month) {
            let dateRecords = this.records.filter((record) => {
                if (record.capacity.available && day === record.dates.day && month === record.dates.month) {
                    return record;
                }
            });

            return dateRecords.length ? 'available' : ''
        },

        isItWeekend(day) {
            let dayDate = moment(this.actualDate).date(day).format('dd');
            return dayDate === 'so' || dayDate === 'ne' ? `week-${dayDate}` : '';
        },

        setCalendarItems() {

            this.activeFilterHallNames = [];

            this.hallnames.map((h) => {
                if (h.active) this.activeFilterHallNames.push(h.name)
            });

            let newItemsSet = [];
            let actualMonth = parseInt(this.actualDate.format('M'));

            for (var i = 1; i < this.actualDate.daysInMonth() + 1; i++) {

                newItemsSet.push({
                    day: i,
                    month: actualMonth,
                    activeClass: '',
                    availableClass: this.isItAvailableDay(i, actualMonth),
                    availabilityInDayClass: this.availabilityInDay(i, actualMonth),
                    // isWeekend: this.isItWeekend(i, actualMonth)
                });
            }

            this.actualMonth = this.actualDate.format('MMMM');
            this.items = newItemsSet;
        },

        getMonth(dir, inc) {
            let d = this.actualDate.clone();
            switch (dir) {
                case 'next':
                    return  d.add(inc ? inc : 1, 'month').format('M');
                case 'prev':
                    return  d.subtract(inc ? inc : 1, 'month').format('M');
                case 'today':
                    return  this.today.format('M');
            }
        },

        setMonth(dir, step) {

            step = step ? step : 1;

            switch (dir) {
                case 'next':
                    this.actualDate.add(1, 'month');
                    break;
                case 'prev':
                    this.actualDate.subtract(1, 'month');
                    break;
                case 'today':
                    this.actualDate = this.today.clone();
                    break;
            }

            this.$emit('dateChange', this.actualDate);

            this.setCalendarItems();
        },

        manualHiLightActualDay() {
            this.hiLightActualDay($(window).scrollTop() + 200);
            this.scrollToQueryDate();
        },

        hiLightActualDay(scrollTop) {
            if (!this.itemsOffsetTop.length) return;

            let closest = this.itemsOffsetTop.reduce((prev, curr) => Math.abs(curr - scrollTop) < Math.abs(prev - scrollTop) ? curr : prev);

            if (this.records[this.itemsOffsetTop.indexOf(closest)]) {
                let day = moment(this.records[this.itemsOffsetTop.indexOf(closest)].date).date();
                let month = parseInt(moment(this.records[this.itemsOffsetTop.indexOf(closest)].date).format('M'));
                let actualMonth = parseInt(this.actualDate.format('M'));
                if (month !== actualMonth) {
                    if (month === 1 && actualMonth === 12) {
                        this.setMonth('next')
                    } else if (month === 12 && actualMonth === 1) {
                        this.setMonth('prev')
                    } else if (month > actualMonth) {
                        this.setMonth('next')
                    } else if (month < actualMonth) {
                        this.setMonth('prev')
                    }

                    this.actualMonth = this.actualDate.format('MMMM')
                }
                this.items.map(function (item) {
                    item.activeClass = item.day === day ? 'active' : '';
                })
            }
        },

        setFixedActions() {
            let $w = $(window);
            let $wrapper = $('#wrapper');
            let $calendar = $('#calendar');
            let calendarOffsetTop = $calendar.offset().top + 3 * parseInt($('body, html').css('font-size'));

            let scope = this;

            $w.on('scroll', function (e) {
                let wst = $w.scrollTop();
                scope.hiLightActualDay(wst + 200);
                if (wst >= calendarOffsetTop && !$calendar.hasClass('is-fixed')) {
                    $wrapper.css('padding-top', $calendar.outerHeight());
                    $calendar.addClass('is-fixed');
                } else if (wst <= calendarOffsetTop && $calendar.hasClass('is-fixed')) {
                    $wrapper.css('padding-top', 0);
                    $calendar.removeClass('is-fixed');
                }
            })
        },

        getQueryParameters(str) {
            return (str || document.location.search).replace(/(^\?)/,'').split("&").map(function(n){return n = n.split("="),this[n[0]] = n[1],this}.bind({}))[0];
        },

        scrollToQueryDate() {
            let q = this.getQueryParameters();

            if (q.day || q.month || q.year) this.scrollToDate(q.day, q.month, q.year);
        },

        scrollToDate(d,m,y) {

            var selector = "";
            var target;

            // next, prev
            if (typeof m === 'string') {
                var nextPrevCount = m;
                m = this.getMonth(m);
            }

            if (d) selector += "[data-day='"+d+"']";
            if (m) selector += "[data-month='"+m+"']";
            if (y) selector += "[data-year='"+y+"']";

            target = $(selector)[0];

            if (!target && (nextPrevCount === "next" || nextPrevCount === "prev")) {
                var breakWhile = 12;
                while (breakWhile && !target) {
                    breakWhile--;

                    if (nextPrevCount === "next") m++;
                    else if (nextPrevCount === "prev") m--;

                    if (m > 12) m = 0;
                    else if (m === 0) m = 12;

                    selector = "[data-month='"+m+"']";
                    target = $(selector)[0];
                }
            }

            if (target) {
                $('html, body').stop().animate({scrollTop: $(target).offset().top - 120}, 800);
            } else {
                if ($('html, body').scrollTop()) $('html, body').stop().animate({scrollTop: 0}, 800);
            }
        }
    },

    filters: {
        example(value) {
            return value
        }
    },

    watch: {
        hallnames: {
            handler: 'setCalendarItems',
            deep: true
        },
        timeline: {
            handler: 'setCalendarItems'
        },
        itemsOffsetTop: {
            handler: 'manualHiLightActualDay'
        },
    },

    mounted() {
        this.setFixedActions();
    },

    template:
`
<div id="calendar" class="container-fluid theme-bg">
    <div class="row">
        <div class="container">
        <h1 class="title-absolute">Program</h1>
            <div class="row">
                <div class="col calendar-title">
        
                    <button @click="scrollToDate(false, 'today')" class="d-inline-block hover-underline btn-invisible cursor-pointer">DNES</button>
        
                    <div class="d-inline-block pl-md-5">
                        <button @click="scrollToDate(false, 'prev')" class="d-inline-block hover-underline btn-invisible cursor-pointer" aria-label="Předchozí měsíc">&lt;</button>
                        <span class="px-0 text-uppercase text-center d-inline-block min-w-6rem" aria-current="date">{{actualMonth}}</span>
                        <button @click="scrollToDate(false, 'next')" class="d-inline-block hover-underline btn-invisible cursor-pointer" aria-label="Následující měsíc">&gt;</button>
                    </div>
        
                    <div class="d-inline-block pl-md-5">
                    
                        <div class="dropdown">
                            <button class="btn-invisible calendar-scene-select-button cursor-pointer js-check-attr-aria-expanded" type="button" id="sceneFilterDropdown" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" aria-current="false">
                                <span>SCÉNA</span> <span class="ml-2 text-decoration-none">&gt;</span>
                            </button>
                            <div class="dropdown-menu mdp-dropdown" aria-labelledby="sceneFilterDropdown">
                                <button v-for="hall in hallnames"
                                    class="dropdown-item text-uppercase"
                                    :class="[hall.active ? 'active' : '']"
                                    @click="hall.active = !hall.active"
                                    >{{hall.name}}</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            
            <div class="row collapse show" id="calendar-days">
                <div class="calendar-days text-left d-lg-flex flex-row justify-content-around pb-1 px-2 w-100">
                    <div v-for="item in items" class="calendar-item" :class="item.activeClass">
                        <button :disabled="item.availableClass == '' || item.availabilityInDayClass == ''" :class="[item.isWeekend, item.availabilityInDayClass]" @click="scrollToDate(item.day, item.month)">{{item.day}}</button>
                    </div>
                </div> 
            </div>
            <div class="row d-lg-none">
                <div class="col text-right">
                    <button class="btn btn-invisible btn-calendar-days" type="button" data-toggle="collapse" data-target="#calendar-days"></button>
                </div>            
            </div>
        </div>
    </div>
</div>
`
});

function switchExpandedTwo() {
    var x = document.getElementById("sceneFilterDropdown").getAttribute("aria-current"); 
    if (x == "false") 
    {
    x = "true";
    } else {
    x = "false"
    }
    document.getElementById("sceneFilterDropdown").setAttribute("aria-current", x);
}

Vue.component('comp-citation', {

    props: ['citation'],

    template:
`
<div class="col-12" v-if="citation">
    <div class="row pb-5 pt-3">
        <div class="col-6 col-sm-4 col-md-2 pt-4">
            <h4 class="text-uppercase mb-0" v-html="citation.title"></h4>
            <h4 class="text-uppercase" v-html="citation.smallContent"></h4>
        </div>
        <div class="col-12 col-sm-8 col-md-8  text-center">
            <h4 class="text-kr text-kr-big citation-text" v-html="citation.content"></h4>
        </div>
    </div>
</div>
`
});


let programApp = new Vue({

    el: '#vue-program',

    data: {
        urls: {
            records: '/ajax/program/'
        },
        allRecords: [],
        records: [],
        citations: [],
        timeline: [],
        citationsPositions: [],
        hallnames: [],
        itemsOffsetTop: [],
        actualDate: moment(),
    },

    methods: {

        getRecords() {

            this.$http.get(this.urls.records, {
                headers: {
                    'Access-Control-Allow-Origin': '*',
                    'Access-Control-Allow-Methods': 'POST, GET, PUT, OPTIONS, DELETE',
                    'Access-Control-Allow-Headers': 'Access-Control-Allow-Methods, Access-Control-Allow-Origin, Origin, Accept, Content-Type',
                    'Content-Type': 'application/json',
                    'Accept': 'application/json'
                }
            }).then(response => {
                this.allRecords = response.body.records;
                this.timeline = response.body.timeline;
                this.citationsPositions = response.body.citationsPositions;
                this.hallnames = response.body.hallnames;
                this.citations = response.body.citations;

                this.records = this.cloneArray(this.allRecords);
            }, response => {
                console.log('getRecords: Error', response.status);
            });
        },

        onItemsOffsetTop(itemsOffsetTop) {
            this.itemsOffsetTop = itemsOffsetTop;
        },

        cloneArray(obj) {
            return Object.assign([], obj);
        },

        filterRecordsByHallNames() {
            let activeHallNames = [];

            this.hallnames.map((hall) => {
                if (hall.active) activeHallNames.push(hall.name);
            });

            if (!activeHallNames.length) {
                this.records = this.allRecords;
            } else {
                this.records = this.allRecords.filter((rec) => {
                    return activeHallNames.indexOf(rec.hall) >= 0;
                });
            }
        },

    },

    mounted() {
        this.getRecords();
    },

    watch: {
        hallnames: {
            handler: 'filterRecordsByHallNames',
            deep: true
        }
    },

    template:
`
    <div>
        <comp-calendar
            :actualDate="actualDate"
            :records="records"
            :timeline="timeline"
            :hallnames="hallnames"
            :itemsOffsetTop="itemsOffsetTop"></comp-calendar>
        <comp-records
            :records="records"
            :citations="citations"
            :citationsPositions="citationsPositions"
            :hallnames="hallnames"
            @itemsOffsetTop="onItemsOffsetTop"></comp-records>
    </div>
`
});
